import View from './View'

const Container = () => <View title="Dados User" />

export default Container
